import { InvoiceLine } from "../../types";

interface InvoiceLinesPreviewProps {
  lines: InvoiceLine[];
  total: number;
  totalLabel: string;
}

export function InvoiceLinesPreview({
  lines,
  total,
  totalLabel,
}: InvoiceLinesPreviewProps) {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
      <div className="text-xs font-semibold text-amber-800 uppercase tracking-wide mb-3">
        Invoice Preview (What customer sees)
      </div>
      <div className="space-y-1.5">
        {lines.map((line, i) => (
          <div key={i} className="flex justify-between items-start gap-4 text-xs">
            <span className={`${line.isDiscount ? 'text-success-dark italic' : 'text-content-primary'} flex-1 min-w-0`}>
              {line.description}
            </span>
            <span className={`font-medium shrink-0 ${line.isDiscount ? 'text-success-dark' : 'text-content-primary'}`}>
              {line.amount < 0 ? '-' : ''}${Math.abs(line.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
        ))}
        <div className="border-t border-amber-300 mt-2 pt-2 flex justify-between items-center">
          <span className="text-sm font-semibold text-content-primary">
            {totalLabel}
          </span>
          <span className="text-sm font-bold text-content-primary">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>
    </div>
  );
}
